/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { CertificationPeriodSuggestionViewModel } from './CertificationPeriodSuggestionViewModel'; 

export function getCertificationPeriodSuggestedFrequenciesOptions(certificationPeriodId: string, onSuccess?: (result?: CertificationPeriodSuggestionViewModel) => void) {
	return queryOptions({
		queryKey: ['certification-period-suggested-frequencies', certificationPeriodId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/careplanning/suggestedfrequencies/queries/getcertificationperiodsuggestedfrequencies/' + certificationPeriodId;
			const resp = await axios.get<CertificationPeriodSuggestionViewModel | null>(url);
	        const result = resp.data ?? null;
	        onSuccess?.(result ?? undefined);
	        return result;
        },
        select: (x) => x ?? undefined,
        enabled: Boolean(certificationPeriodId)
	});
}